import moment from 'moment';
import { getMomentLocale } from './appLocale';

export function formatHmrPeriodLabel(period, language = 'es') {
  if (!period || typeof period !== 'string') return '';

  const locale = getMomentLocale(language);
  let year;
  let monthNum;

  if (period.length === 6 && /^\d{6}$/.test(period)) {
    year = parseInt(period.slice(0, 4), 10);
    monthNum = parseInt(period.slice(4, 6), 10);
  } else if (period.includes('-')) {
    const [y, m] = period.split('-');
    year = parseInt(y, 10);
    monthNum = parseInt(m, 10);
  } else {
    return period;
  }

  if (!Number.isFinite(year) || !Number.isFinite(monthNum) || monthNum < 1 || monthNum > 12) {
    return period;
  }

  return moment({ year, month: monthNum - 1 })
    .locale(locale)
    .format('MMMM YYYY');
}
